import React, { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import '@brainhubeu/react-carousel/lib/style.css';
import { Link, useHistory, useParams, useRouteMatch } from 'react-router-dom';
import MainCategoryListContainer from '../MainCategoryListContainer/MainCategoryListContainer';
import ProductList from '../../../containers/shop/ProductList/ProductList';
import FeaturedProductsCarousel from '../../../containers/shop/Carousel/FeaturedProductsCarousel';
import PromotionalProductsCarousel from '../../../containers/shop/Carousel/PromotionalProductsCarousel';
import OwlCarousel from 'react-owl-carousel2';

import './owl.carousel.css';
import { observer } from "mobx-react";
import { useStores } from "../../../hooks/use-stores";
import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import {joinPath} from "../../../utils/helpers";

const useStyles = makeStyles((theme) => ({
    link: {
        width: "100%",
    },
    pic: {
        cursor: "pointer",
        maxWidth: 120,
        backgroundColor: "rgba(255, 255, 255, 0)",
        width: "120px !important",
        height: "120px !important",
        marginBottom: 40,
        borderRadius: "10%",
        [theme.breakpoints.down('md')]: {
            width: "100px !important",
            height: "100px !important",
        },
        [theme.breakpoints.down('sm')]: {
            width: "80px !important",
            height: "80px !important",
        },
    },
    featuredProducts:{
        [theme.breakpoints.down('sm')]: {
            marginTop: 20,
        },
    }
}));


function HomeMainContent({ shoppingMatch }) {
    const history = useHistory();
    const params = useParams();
    const match = useRouteMatch();
    const classes = useStyles();
    const { categoryId } = params;
    const { t } = useTranslation();
    const { authStore, shopStore, commonStore } = useStores();
    const [homeIconDisplay, setHomeIconDisplay] = useState({
        marketplaceIconDisplay: {
            displayicon: false,
            link: "/category/790",
            imageURL: "https://resources.lifeinfoapp.com/public/icon/marketplace_en.jpg"
        },
        zinzinoIconDisplay: {
            displayicon: false,
            link: "/category/790/sub-category/786",
            imageURL: "https://resources.lifeinfoapp.com/public/icon/zinzino.png"
        },
        muscadineIconDisplay: {
            displayicon: false,
            link: "/category/790/sub-category/788",
            imageURL: "https://resources.lifeinfoapp.com/public/icon/mighty_muscadine.jpg"
        },
        xebecIconDisplay: {
            displayicon: false,
            link: "/category/790/sub-category/782",
            imageURL: "https://resources.lifeinfoapp.com/public/icon/xebec.png"
        },
        honeyBarsIconDisplay: {
            displayicon: false,
            link: "/category/790/sub-category/794",
            imageURL: "https://resources.lifeinfoapp.com/public/icon/honeybar.jpg"
        },
        autoShipIconDisplay: {
            displayicon: false,
            link: "/autoship",
            imageURL: "https://resources.lifeinfoapp.com/public/icon/Autoship.jpg"
        },
        goldshieldIconDisplay: {
            displayicon: false,
            link: "/category/790/sub-category/795",
            imageURL: "https://resources.lifeinfoapp.com/public/icon/goldshield.png"
        },

        olivierIconDisplay: {
            displayicon: false,
            link: "/category/790/sub-category/812",
            imageURL: "https://resources.lifeinfoapp.com/public/icon/olivier.jpg"
        },
        monavieIconDisplay: {
            displayicon: false,
            link: "/category/790/sub-category/835",
            imageURL: "https://resources.lifeinfoapp.com/public/icon/Monavie.jpg"
        },
        roccocoIconDisplay: {
            displayicon: false,
            link: "/category/790/sub-category/825",
            imageURL: "https://resources.lifeinfoapp.com/public/icon/Roccoco.jpg"
        },
        trulyGoodFoodsIconDisplay: {
            displayicon: false,
            link: "/category/790/sub-category/814",
            imageURL: "https://resources.lifeinfoapp.com/public/icon/Truly-Good-Foods.jpg"
        }
    });
    const { isGuest } = authStore;
    const { memberCategories, publicCategories, promotionalProducts, featuredProducts, market, customerLevelID } = shopStore;
    const { language } = commonStore;
    const { currentUser, shoppingUserDetails, country } = authStore;
    // const {address, shoppingUserDetails} = currentUser;
    //const {country} = address;


    useEffect(() => {
        if (language && (!isGuest || (market && customerLevelID))) {
            shopStore.loadPromotionalProducts(
                {
                    customerLevelID
                    , marketID: market, language
                });
            shopStore.loadFeaturedProducts(
                {
                    customerLevelID
                    , marketID: market, language
                });
        }
    }, [market, customerLevelID, language]);


    useEffect(() => {
        var marketplaceCountries = ["US", "CA", "BS", "DO", "HT", "AU", "FR", "MX"];
        var muscadineCountries = ["US", "CA", "BS", "DO", "HT", "MX"];
        var zinzinoCountries = ["US", "CA", "BS", "DO", "HT", "AU", "FR"];
        var snaxXebecCountries = ["US", "CA", "BS", "DO", "HT"];
        var bShowMarketplace = (marketplaceCountries.indexOf(country) > -1);
        var bShowZinzino = (zinzinoCountries.indexOf(country) > -1);
        var bShowMuscadine = (muscadineCountries.indexOf(country) > -1);
        var bShowHoneyBars = (snaxXebecCountries.indexOf(country) > -1);
        var bShowGoldShield = (snaxXebecCountries.indexOf(country) > -1);
        var bShowXebec = (snaxXebecCountries.indexOf(country) > -1);
        var bShowOlivier = (snaxXebecCountries.indexOf(country) > -1);
        var bShowMonavie = (marketplaceCountries.indexOf(country) > -1);
        var bShowRoccoco = (marketplaceCountries.indexOf(country) > -1);
        var trulyGoodFoodsCountries = ["CA", "BS", "DO", "HT", "AU", "FR", "MX"];
        var bTrulyGoodFoods = (trulyGoodFoodsCountries.indexOf(country) > -1);
        var bShowAutoship = true;

        setHomeIconDisplay(prevState => ({
            marketplaceIconDisplay: {
                ...prevState.marketplaceIconDisplay,
                displayicon: bShowMarketplace,
            },
            goldshieldIconDisplay: {
                ...prevState.goldshieldIconDisplay,
                displayicon: bShowGoldShield,
            },
            olivierIconDisplay: {
                ...prevState.olivierIconDisplay,
                displayicon: bShowOlivier,
            },
            zinzinoIconDisplay: {
                ...prevState.zinzinoIconDisplay,
                displayicon: bShowZinzino,
            },
            muscadineIconDisplay: {
                ...prevState.muscadineIconDisplay,
                displayicon: bShowMuscadine,
            },
            xebecIconDisplay: {
                ...prevState.xebecIconDisplay,
                displayicon: bShowXebec,
            },
            honeyBarsIconDisplay: {
                ...prevState.honeyBarsIconDisplay,
                displayicon: bShowHoneyBars,
            },
            autoShipIconDisplay: {
                ...prevState.autoShipIconDisplay,
                displayicon: bShowAutoship,
            },
            monavieIconDisplay: {
                ...prevState.monavieIconDisplay,
                displayicon: bShowMonavie,
            },
            roccocoIconDisplay: {
                ...prevState.roccocoIconDisplay,
                displayicon: bShowRoccoco,
            },
            trulyGoodFoodsIconDisplay: {
                ...prevState.trulyGoodFoodsIconDisplay,
                displayicon: bTrulyGoodFoods,
            }
        }));
    }, [country]);


    useEffect(() => {

    }, [market, customerLevelID]);


    const onFeaturedProductsHandler = () => {
        history.push(`${match.url}/category/${793}`);
    };

    const onAutoShipClick = () => {
        shopStore.toggleAutoshipBanner();
        window.scrollTo(0, 0);
    };


    const homeIcons = useMemo(() => {
        let homeIcons = [];
        for (const key of Object.keys(homeIconDisplay)) {
            if (homeIconDisplay[key].displayicon === true) {
                homeIcons.push(
                    <div key={homeIconDisplay[key].imageURL} className="owl-stage">
                        <Link className={classes.link} to={joinPath( match.url, homeIconDisplay[key].link ) } key={homeIconDisplay[key].link}>
                            <img
                                className={classes.pic}
                                src={homeIconDisplay[key].imageURL}
                                alt=""
                            />
                        </Link>
                    </div>);
            }
        }
        console.log("homeIcons", homeIcons)
        return homeIcons;
    }, [homeIconDisplay]);

    let displayLoop = false;
    let center = false;
    if (homeIcons.length > 4) {
        displayLoop = true;
        center = true;
    }
    const options = {
        loop: displayLoop,
        nav: false,
        center: center,
        autoplay: false,
        dots: false,
        mouseDrag: true,
        touchDrag: true,
        responsive: {
            0: {
                items: 3,
            },
            350: {
                items: 4,
            },
            600: {
                items: 6,
            },
            800: {
                items: 8,
            },
            1200: {
                items: 8,
            },
        }
    };

    return <Container maxWidth={"md"} className="main-content__wrapper">
        <Grid container className={classes.featuredProducts}>
            {featuredProducts
                && <>
                    <Grid container item className="main-content__featured-products__header">
                        <Grid container item alignItems={"center"} xs={6}><Typography variant={"subtitle1"}>{t('shopping:home.featuredproducts')}</Typography></Grid>
                        <Grid container item alignItems={"center"} xs={6} justifyContent={"flex-end"}><Typography variant={"subtitle1"} onClick={onFeaturedProductsHandler}>{t('shopping:subcategories.seeall')}</Typography></Grid>
                    </Grid>
                    {
                        featuredProducts.length < 4 ? (
                            <div>
                                <ProductList
                                    category={'featured-products'}
                                    products={featuredProducts}
                                />
                            </div>
                        ) : (
                            <FeaturedProductsCarousel products={featuredProducts} parentMatch={match} />
                        )
                    }
                </>}

        </Grid>

        <div className="main-content__categories">
            <MainCategoryListContainer
                homeContainerTitle={'Categories'}
                categoryItems={publicCategories}
            />
        </div>

        {

            (isGuest || !currentUser || !currentUser.isMember) ? (
                ''
            ) : (
                <div className="main-content__member">
                    <MainCategoryListContainer
                        homeContainerTitle={'Membery Categories Only'}
                        categoryItems={memberCategories}
                        onAutoShipClick={onAutoShipClick}
                    />
                </div>
            )
        }
    </Container>;

}

export default observer(HomeMainContent);